import { forwardRef, ForwardRefRenderFunction } from 'react';
import { Modal, ModalContent, ModalProps } from '@chakra-ui/react';

type OnboardingFullPageProps = Omit<
  ModalProps,
  'closeOnEsc' | 'closeOnOverlayClick' | 'isOpen' | 'onClose' | 'size'
> & {
  'data-testid'?: string;
};

/**
 * @info
 * This component is ONLY meant to be used during Tempura's migration of onboarding modules.
 * It wraps a legacy page that should display in full page (like the agreements and plan choice).
 */
const OnboardingFullPage: ForwardRefRenderFunction<
  HTMLElement,
  OnboardingFullPageProps
> = ({ children, 'data-testid': dataTestid, ...props }, ref) => {
  return (
    <Modal
      closeOnEsc={false}
      closeOnOverlayClick={false}
      isOpen
      onClose={() => null}
      {...props}
    >
      <ModalContent
        borderRadius="0"
        bottom="0"
        left="0"
        marginBottom="0"
        marginTop="0"
        position="absolute"
        ref={ref}
        right="0"
        top="0"
        {...(dataTestid !== undefined ? { 'data-testid': dataTestid } : {})}
      >
        {children}
      </ModalContent>
    </Modal>
  );
};

export default forwardRef(OnboardingFullPage);
